import { PoleClassification } from '../../../../../api/theHive/redeProto/types';
import { THRESHOLDS } from '../../../../../constants/redeProto';

/** Converte uma nota 0–100 em classificação (mesma escala do BSC). */
export const scoreToClassification = (score: number): PoleClassification => {
  if (score >= THRESHOLDS.score.excellent) return 'excellent';
  if (score >= THRESHOLDS.score.healthy) return 'healthy';
  if (score >= THRESHOLDS.score.critical) return 'attention';
  return 'critical';
};
